require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./introduction-to-inspire.json") })
        }
      }, "path---introduction-to-inspire");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---introduction-to-inspire!./.cache/json/introduction-to-inspire.json
// module id = 369
// module chunks = 231608221292675